
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18891.084 -23813.699 15.625 14.4"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_161_1","data-name":"Symbol 161 – 1","transform":"translate(-19908.385 -24999.001)","opacity":".74"}},[_c('g',{attrs:{"id":"Group_7733","data-name":"Group 7733","transform":"translate(216 829)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Rectangle_1659","d":"M0 0h14.226v5.164H0z","data-name":"Rectangle 1659","transform":"translate(802 357)"}}),_c('g',{attrs:{"id":"Group_5695","data-name":"Group 5695","transform":"translate(804.196 359.018)"}},[_c('path',{staticClass:"cls-3",attrs:{"id":"Rectangle_1660","d":"M0 0h1.128v1.128H0z","data-name":"Rectangle 1660"}}),_c('path',{staticClass:"cls-3",attrs:{"id":"Rectangle_1661","d":"M0 0h1.128v1.128H0z","data-name":"Rectangle 1661","transform":"translate(2.553)"}})]),_c('path',{staticClass:"cls-2",attrs:{"id":"Rectangle_1663","d":"M0 0h14.226v5.164H0z","data-name":"Rectangle 1663","transform":"translate(802 364.836)"}}),_c('g',{attrs:{"id":"Group_5697","data-name":"Group 5697","transform":"translate(804.196 366.854)"}},[_c('path',{staticClass:"cls-3",attrs:{"id":"Rectangle_1664","d":"M0 0h1.128v1.128H0z","data-name":"Rectangle 1664"}}),_c('path',{staticClass:"cls-3",attrs:{"id":"Rectangle_1665","d":"M0 0h1.128v1.128H0z","data-name":"Rectangle 1665","transform":"translate(2.553)"}})])])])])
          )
        }
      }
    